// Hero — home page first screen. Stats count up from 0 to their value on scroll into view.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Animate every .hero__stat-number from 0 up to its data-value when it scrolls into view. A
// data-suffix (e.g. "+") is preserved.
function initStatsCountUp() {
  document.querySelectorAll('.hero__stat-number').forEach((el) => {
    // Target is read from the element's own text (e.g. "15+", "$2.5M")
    // unless a data-value attribute is present. Prefix/suffix is preserved.
    const raw = (el.textContent || '').trim();
    const match = raw.match(/\d[\d,.]*/);
    if (!match && el.dataset.value == null) return;

    const numStr = el.dataset.value != null ? el.dataset.value : match[0];
    const target = parseFloat(String(numStr).replace(/,/g, ''));
    if (Number.isNaN(target)) return;

    const decimals = (String(numStr).split('.')[1] || '').length;
    const prefix = match ? raw.slice(0, match.index) : '';
    const suffix = match ? raw.slice(match.index + match[0].length) : (el.dataset.suffix || '');

    const format = (v) =>
      prefix + (decimals ? v.toFixed(decimals) : Math.round(v)) + suffix;

    const counter = { val: 0 };
    gsap.to(counter, {
      val: target,
      duration: 1.5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        once: true,
      },
      onUpdate() {
        el.textContent = format(counter.val);
      },
      onComplete() {
        el.textContent = format(target);
      },
    });
  });
}

export default function initHero() {
  if (!document.querySelector('.hero')) return;
  initStatsCountUp();
}
